<template>
    <div class="wrapper"
         :class="[breakColumn ? 'wrapper-break-' + breakColumn : null, {'wrapper-stretch': stretch, 'wrapper-grow': grow, 'has-break-reverse': breakReverse, 'justify-start': left, 'justify-center': center, 'justify-between': between, 'justify-end': !left && !center && !between}]">
        <slot v-bind:column="column"/>
    </div>
</template>

<script>
import Alignable from "../../mixins/Alignable";

    export default {
        name: "Wrapper",

        mixins: [Alignable],

        props: {

            // The column name on which to break the content
            breakColumn: {
                type: String,
                default: null
            },

            // Whether to reverse the element order on break
            breakReverse: {
                type: Boolean,
                default: false
            },

            // Whether to align the items with 'justify-between'
            between: {
                type: Boolean,
                default: false
            },

            // Whether the content shall take the full parent's width up to a max width of 300px for each item
            grow: {
                type: Boolean,
                default: false
            },

            // Whether the content shall take the full parent's width without an individual width limit
            stretch: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            column() {
                switch (this.breakColumn) {
                    case 'xs':
                        return this.$breakpoint.xsOnly;
                    case 'sm':
                        return this.$breakpoint.smAndDown;
                    case 'md':
                        return this.$breakpoint.mdAndDown;
                    case 'lg':
                        return this.$breakpoint.lgAndDown;
                    case 'xl':
                        return this.$breakpoint.xlOnly;
                }
                return false
            }
        }
    }
</script>

<style>
/* ==========================================================================
   Mixins
   ========================================================================== */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
}
.wrapper.wrapper-grow > *:not(span), .wrapper.wrapper-stretch > *:not(span) {
  flex-grow: 1;
  margin-bottom: 0 !important;
  margin-top: 0;
}
.wrapper.wrapper-grow > *:not(span):only-child {
  width: 100%;
}
@media (min-width: 640px) {
  .wrapper:not(.wrapper-stretch) > *:not(span) {
    max-width: 300px;
  }
}
@media screen and (min-width: 640px) and (-ms-high-contrast: active), (min-width: 640px) and (-ms-high-contrast: none) {
  .wrapper:not(.wrapper-stretch) > *:not(span) {
    max-width: none;
  }
}
@media (min-width: 640px) {
  .wrapper:not(.wrapper-stretch) > *:not(span).v-btn--icon.v-size--default {
    height: 36px !important;
    width: 36px !important;
    max-width: 36px !important;
  }
}
.wrapper > *:not(span):not(:first-child):not(:only-child) {
  margin-left: 8px;
}
@media (max-width: 639px) {
  .wrapper.wrapper-break-xs {
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }
  .wrapper.wrapper-break-xs > *:not(span) {
    width: 100%;
  }
  .wrapper.wrapper-break-xs > *:not(span):not(:first-child):not(:only-child) {
    margin-top: 10px;
    margin-left: 0;
  }
  .wrapper.wrapper-break-xs.has-break-reverse {
    flex-direction: column-reverse;
  }
  .wrapper.wrapper-break-xs.has-break-reverse > *:not(span):not(:first-child):not(:only-child) {
    margin-bottom: 8px !important;
    margin-top: 0;
  }
}
@media (max-width: 767px) {
  .wrapper.wrapper-break-sm {
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }
  .wrapper.wrapper-break-sm > *:not(span) {
    width: 100%;
  }
  .wrapper.wrapper-break-sm > *:not(span):not(:first-child):not(:only-child) {
    margin-top: 10px;
    margin-left: 0;
  }
  .wrapper.wrapper-break-sm.has-break-reverse {
    flex-direction: column-reverse;
  }
  .wrapper.wrapper-break-sm.has-break-reverse > *:not(span):not(:first-child):not(:only-child) {
    margin-bottom: 8px !important;
    margin-top: 0;
  }
}
@media (max-width: 1023px) {
  .wrapper.wrapper-break-md {
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }
  .wrapper.wrapper-break-md > *:not(span) {
    width: 100%;
  }
  .wrapper.wrapper-break-md > *:not(span):not(:first-child):not(:only-child) {
    margin-top: 10px;
    margin-left: 0;
  }
  .wrapper.wrapper-break-md.has-break-reverse {
    flex-direction: column-reverse;
  }
  .wrapper.wrapper-break-md.has-break-reverse > *:not(span):not(:first-child):not(:only-child) {
    margin-bottom: 8px !important;
    margin-top: 0;
  }
}
@media (max-width: 1279px) {
  .wrapper.wrapper-break-lg {
    flex-direction: column;
    margin-top: 8px;
    width: 100%;
  }
  .wrapper.wrapper-break-lg > *:not(span) {
    width: 100%;
  }
  .wrapper.wrapper-break-lg > *:not(span):not(:first-child):not(:only-child) {
    margin-top: 10px;
    margin-left: 0;
  }
  .wrapper.wrapper-break-lg.has-break-reverse {
    flex-direction: column-reverse;
  }
  .wrapper.wrapper-break-lg.has-break-reverse > *:not(span):not(:first-child):not(:only-child) {
    margin-bottom: 8px !important;
    margin-top: 0;
  }
}
.wrapper.wrapper-break-xl {
  flex-direction: column;
  margin-top: 8px;
  width: 100%;
}
.wrapper.wrapper-break-xl > *:not(span) {
  width: 100%;
}
.wrapper.wrapper-break-xl > *:not(span):not(:first-child):not(:only-child) {
  margin-top: 10px;
  margin-left: 0;
}
.wrapper.wrapper-break-xl.has-break-reverse {
  flex-direction: column-reverse;
}
.wrapper.wrapper-break-xl.has-break-reverse > *:not(span):not(:first-child):not(:only-child) {
  margin-bottom: 8px !important;
  margin-top: 0;
}
</style>